module.exports = __webpack_public_path__ + "img/Photo-CV.f0c6b583.jpeg";